// Deep import intentional, as turbopack only honors `.web.*` priority at the
// project→node_modules boundary, not for the package's own internal
// relative imports. Importing through `react-native-mmkv`'s index pulls the
// native variant into the web bundle.
import { createMMKV } from "react-native-mmkv/lib/createMMKV/createMMKV";

import type { StorageOptions, SyncStorage } from "./types";

export const createSyncStorage = (options: StorageOptions): SyncStorage => {
  const mmkv = createMMKV({ id: options.namespace });
  return {
    get: key => mmkv.getString(key) ?? null,
    set: (key, value) => {
      mmkv.set(key, value);
    },
    remove: key => {
      mmkv.remove(key);
    },
  };
};
